import { styled } from '@mui/system';
import { ContentContainer } from '@components/ContentContainer';
import { Typography } from '@mui/material';

const ContentContainerDiv = styled(ContentContainer)({
  backgroundColor: '#F9F9F9',
});

const ContentDiv = styled('div')({
  display: 'flex',
  padding: '16px 12px',
  flexDirection: 'column',
  minHeight: 'calc(100vh - 64px - 80px)',
  '@media (min-width: 900px)': {
    minHeight: 'calc(88vh - 64px - 80px)',
  },
});

interface ButtonDivProps {
  isAbsolute: boolean;
}

const ButtonDiv = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isSticky',
})<ButtonDivProps>(({ isAbsolute }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center',
  position: 'sticky',
  bottom: '0',
  width: '100%',
  height: '80px',
  backgroundColor: 'white',
  borderTop: '2px solid #EAEAEA',
  ...(isAbsolute && {
    position: 'absolute',
  }),
}));

const Button = styled('button')({
  backgroundColor: '#0A7ABE',
  borderRadius: '100px',
  padding: '8px 60px',
  cursor: 'pointer',
  border: 'none',
});

const TypographyButton = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '0.15px',
  color: 'white',
});

const ErrorTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '16px',
  letterSpacing: '0.15px',
  color: '#D32F2F',
  marginTop: '17px',
});

export {
  ContentDiv,
  ContentContainerDiv,
  ButtonDiv,
  Button,
  TypographyButton,
  ErrorTypography,
};
